// ScopeType enum (SuperGraph) currently omits some legacy scope values.
export const INVALID_SUPERGRAPH_SCOPE_TYPES = new Set(['all_users_and_teams'])

export const isValidSupergraphScopeType = (scopeType) => Boolean(scopeType) && !INVALID_SUPERGRAPH_SCOPE_TYPES.has(scopeType)
